import React from "react";
import Dialog from "./Dialog";
import Icon from "./Icon";
import { AuthContext } from "./Layout";
import SignupForm from "./SignupForm";

export default ({ marketOpen, location }) => {
  const user = React.useContext(AuthContext);

  if (marketOpen || user) {
    return null;
  }

  return <UserExitDialogBody location={location} />;
};

let hasOpened = false;

function UserExitDialogBody({ location }) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const listener = () => {
      if (!hasOpened) {
        hasOpened = true;
        setOpen(true);
      }
    };

    window.document.addEventListener("mouseleave", listener);

    return () => {
      window.document.removeEventListener("mouseleave", listener);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={600}
      disableBackdropClick
    >
      <div className="add-padding-2">
        <button className="btn close-btn" onClick={handleClose}>
          <Icon width={18} iconName="times" />
        </button>
        <div>
          <h3 style={{ marginBottom: 8 }}>Before you go...</h3>
          <p style={{ marginBottom: 24 }}>
            Our farmers are tilling! Create a free till account to get notified
            about updates regarding Sunday's fresh harvest.
          </p>
          <SignupForm location={location} />
        </div>
      </div>
    </Dialog>
  );
}
